import { AttendedEventsContext } from '@account/contexts';
import { AttendedEventsDesktop, AttendedEventsMobile } from '@account/routes/AccountEvents/tabs/AttendedEvents';
import { RegistrationEventListItem } from '@event/types';
import { useLazyDownload } from '@hooks/useDownload';
import { useMediaQuery } from '@mui/material';
import { useState } from 'react';

export const AttendedEvents = () => {
    //#region State
    const [downloadingCertificateKey, setDownloadingCertificateKey] = useState<Record<string, boolean>>({});
    //endregion

    //#region Hooks
    const isMdOrAbove = useMediaQuery((theme) => theme.breakpoints.up('md'));
    const [downloadCertificates] = useLazyDownload();
    //#endregion

    const handleDownloadCertificate = async (event: RegistrationEventListItem) => {
        const certificateKey = `${event.type}-${event.id}`;

        setDownloadingCertificateKey((prev) => ({ ...prev, [certificateKey]: true }));

        try {
            await downloadCertificates({ relativePath: `public/events/${event.type}/${event.id}/certificate/`});
        } finally {
            setTimeout(() => {
                setDownloadingCertificateKey((prev) => ({ ...prev, [certificateKey]: false }));
            }, 5000);
        }
    };

    return (
        <AttendedEventsContext.Provider value={{ downloadingCertificateKey, handleDownloadCertificate }}>
            {isMdOrAbove ? <AttendedEventsDesktop /> : <AttendedEventsMobile />}
        </AttendedEventsContext.Provider>
    );
};
